import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const User = {
  template: '<div class="user">\n' +
    '      <h2>User {{ $route.params.id }}</h2>\n' +
    '      <router-view></router-view>\n' +
    '    </div>'
}


export default new Router({
  base: process.env.BASE_URL,
  // base: __dirname,
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/components/LandingPage'),
    },
    {
      path: '/search/:keyword',
      name: 'search',
      component: () => import('@/components/SearchPage'),
    },
    {
      path: '/itemView/:id(.*)',
      name: 'item_view',
      component: () => import('@/components/EMBD/ItemView'),
    },
    {
      path: '/embdView/:id',
      name: 'embd_view',
      component: () => import('@/components/EMBD/EMBDView'),
    },
    {
      path: '/movieView/:gene/:id',
      name: 'movie_view',
      component: () => import('@/components/EMBD/MovieView'),
    },
    {
      path: '/figureView/:id',
      name: 'figure_view',
      component: () => import('@/components/EMBD/FigureView'),
    },
    {
      path: '/manualAnno/:id',
      name: 'manaul_anno_view',
      component: () => import('@/components/EMBD/ManualAnno'),
    },
    {
      path: '/eecdView/:id',
      name: 'eecd_view',
      component: () => import('@/components/EECD/EECDItemView'),
    },
    {
      path: '/assayList/:geneLocus/:name/:rnaId',
      name: 'assay_list',
      component: () => import('@/components/EECD/AssayList'),
    },
    {
      path: '/dicResult/:geneLocus/:name/:rnaId/:experimentId/:dicName',
      name: 'dic_result',
      component: () => import('@/components/EECD/DICResult'),
    },
    {
      path: '/gmView/:id',
      name: 'gm_view',
      component: () => import('@/components/GM/GmView'),
    },
    {
      // <a :href="'/gmResultView/' + itemLocus + '/' + response.rnaName + '/' + response.rnaId">
      path: '/gmResultView/:geneLocus/:rnaName/:rnaId',
      name: 'gm_result_view',
      component: () => import('@/components/GM/ResultView'),
    },
    {
      path: '/controlMovies',
      name: 'gm_control_movies',
      component: () => import('@/components/GM/ControlMovies'),
    },
    {
      path: '/explainGonadSterility',
      name: 'gm_gonad_sterility',
      component: () => import('@/components/GM/ExplainGonadSterility'),
    },
    {
      path: '/explainGonadDefects',
      name: 'gm_gonad_defects',
      component: () => import('@/components/GM/ExplainGonadDefects'),
    },
    {
      path: '/gmPhenoGenesView/:classId/:phenoId',
      name: 'gm_pheno_genes_view',
      component: () => import('@/components/GM/PhenoGenesView'),
    },
    {
      path: '/eecdProjectDescription',
      name: 'eecd_project_description',
      component: () => import('@/components/EECD/ProjectDescription'),
    },
    {
      path: '/embdProjectDescription',
      name: 'embd_project_description',
      component: () => import('@/components/EMBD/ProjectDescription'),
    },
    {
      path: '/gmProjectDescription',
      name: 'gm_project_description',
      component: () => import('@/components/GM/ProjectDescription'),
    },
    {
      path: '/umapView/:gene/:id',
      name: 'umap_view',
      component: () => import('@/components/EMBD/UMAPView'),
    },
    {
      path: '/wormBase/:wb_id',
      name: 'wormbase',
      component: () => import('@/components/EMBD/WormBase'),
    },
    // {
    //   path: '*',
    //   redirect: '/',
    // },
  ],
  path: '*', redirect: '/'
})
